// types/myOfferProductsTypes.ts
export const MY_OFFER_PRODUCTS_TYPES = {
  CREATE_OFFER_PRODUCT: 'Create_offer-product',
  CREATE_OFFER_PRODUCT_SUCCESS: 'create_offer_product_success',
  GET_PRODUCT_BY_ID_SUCCESS: 'get_product_by_id_success',
  GET_OFFER_PRODUCTS_LIST: 'get_offer_products_list',
  GET_OFFER_PRODUCTS_LIST_SUCCESS: 'get_offer_products_list_success',
  GET_OFFER_PRODUCTS_LIST_FAILURE: 'get_offer_products_list_failure',
  GET_OFFER_PRODUCTS_LIST_EXPORTER: 'get_offer_products_list_exporter',
  GET_OFFER_PRODUCTS_LIST_EXPORTER_SUCCESS: 'get_offer_products_list_exporter_success',
  GET_OFFER_PRODUCTS_LIST_EXPORTER_FAILURE: 'get_offer_products_list_exporter_failure',
  DELETE_MY_OFFER_PRODUCT:'delete_my_offer_product',
  DELETE_MY_OFFER_PRODUCT_SUCCESS:'delete_my_offer_product_success',
  GET_OFFER_PRODUCT_BY_ID: 'get_product_by_id',
  GET_OFFER_PRODUCT_BY_ID_SUCCESS: 'get_product_by_id_success',
};